import React, { Component } from "react";
import { Link } from "react-router";
import Button from "../../blocks/Button";
import ButtonSet from "../../blocks/ButtonSet";
import { dimensions } from "../../../style/index";
import { css } from "glamor";

const buttonSetStyle = {
  "& > div": {
    padding: "4px 0",
    [dimensions.SCREEN_MAX_SM]: {
      marginRight: 0
    }
  },
  [dimensions.SCREEN_MAX_SM]: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    maxWidth: 200,
    margin: "0 auto"

  }
};
class UserActions extends Component {
  render() {
    return (
      <ButtonSet styles={css(buttonSetStyle)}>
        <Link to="/profile/edit">
          <Button fit variant="simple" size="large">
            Edit Profile
          </Button>
        </Link>
        <Link to="/photos">
          <Button fit variant="simple" size="large">
            Manage photos
          </Button>
        </Link>
      </ButtonSet>
    );
  }
}

export default UserActions;



// WEBPACK FOOTER //
// ./src/components/pages/Profile/UserActions.jsx